import { render } from "./DividerAutoDirection.vue?vue&type=template&id=e6a773de&scoped=true"
import script from "./DividerAutoDirection.vue?vue&type=script&lang=js"
export * from "./DividerAutoDirection.vue?vue&type=script&lang=js"

import "./DividerAutoDirection.vue?vue&type=style&index=0&id=e6a773de&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6a773de"]])

export default __exports__